// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"gp-z","breadcrumbForward":"hp-z","breadcrumbBack":"ip-z","selected":"jp-z"};